import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Avatar, Stack, Tooltip, Typography, } from "@mui/material";
import { useEffect, useState, useCallback } from "react";
import { getContentURL } from "../ContentAPI";
import { authUrl, useCacheBusterStore } from "../util/UrlUtils";
import { useLogger } from "../logger";
const profileImg = "./img/profile_512.jpg";
const LOGPREFIX = "UserAvatar: ";
export const UserAvatar = (props) => {
    const cacheBusterStore = useCacheBusterStore((state) => state);
    const [imageUrl, setImageUrl] = useState(profileImg);
    const [loadedUserId, setLoadedUserId] = useState("");
    const logger = useLogger((state) => state);
    useEffect(() => {
        // If no userId, use default image
        if (!props.userId) {
            logger.log(LOGPREFIX + "user ID not set - using default image");
            if (imageUrl !== profileImg) {
                setImageUrl(profileImg);
                setLoadedUserId("");
            }
            return;
        }
        // If we already loaded this user's image, don't reload
        if (loadedUserId === props.userId && imageUrl !== profileImg) {
            logger.log(LOGPREFIX + "image already loaded for user: " + props.userId);
            return;
        }
        // Only load if we haven't loaded this user's image yet
        if (loadedUserId !== props.userId) {
            logger.log(LOGPREFIX + "loading image for user: " + props.userId);
            const imageSource = authUrl(getContentURL() + "/u/" + props.userId + "/profileImage_256.jpg", cacheBusterStore, props.auth);
            const img = new Image();
            img.onload = () => {
                logger.log(LOGPREFIX + "image loaded successfully for user: " + props.userId);
                setImageUrl(imageSource);
                setLoadedUserId(props.userId);
            };
            img.onerror = () => {
                logger.log(LOGPREFIX +
                    "image load failed for user: " +
                    props.userId +
                    ", using default");
                setImageUrl(profileImg);
                setLoadedUserId(props.userId); // Mark as loaded even if failed to prevent retries
            };
            img.src = imageSource;
            // Cleanup function
            return () => {
                img.onload = null;
                img.onerror = null;
            };
        }
    }, [props.userId, props.auth.isSignedIn()]); // Only depend on userId and auth status
    // Memoize the click handler to prevent unnecessary re-renders
    const handleClick = useCallback(() => {
        logger.log(LOGPREFIX + "onClick");
        props.onUserClicked(props.userId);
    }, [props.userId, props.onUserClicked]);
    return (_jsxs(Stack, Object.assign({ direction: "row", marginLeft: "8px", marginRight: "8px", marginTop: "5px", marginBottom: "5px", paddingLeft: "0", paddingRight: "0", width: "auto", sx: props.sx }, { children: [_jsx(Tooltip, Object.assign({ title: props.tooltip ? props.tooltip : props.userName }, { children: _jsx(Avatar, { alt: props.userName, src: imageUrl, sx: {
                        cursor: "pointer",
                        width: "36px",
                        height: "36px",
                        lineHeight: "40px",
                    }, onClick: handleClick }, props.keyStr + ".avatar") }), props.keyStr + ".tooltip"), props.userName && props.userNameVisible && (_jsx(Typography, Object.assign({ variant: "body1", fontSize: "large", sx: {
                    lineHeight: "35px",
                    cursor: "pointer",
                    paddingLeft: "8px",
                    paddingRight: "8px",
                }, onClick: handleClick, noWrap: true }, { children: props.userName }), props.keyStr + ".username"))] }), props.keyStr + ".stack"));
};
